import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { TeamGoalEntity } from './team-goal.entity';
import { TeamPreferenceEntity } from './team-preference.entity';
import { TeamUserEntity } from './team-user.entity';

@Entity('team')
export class TeamEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@OneToMany(() => TeamGoalEntity, (teamGoal) => teamGoal.fkTeam, {})
	public teamGoals!: Array<TeamGoalEntity>;

	@OneToMany(
		() => TeamPreferenceEntity,
		(teamPreference) => teamPreference.fkTeam,
		{},
	)
	public teamPreferences!: Array<TeamPreferenceEntity>;

	@OneToMany(() => TeamUserEntity, (teamUser) => teamUser.fkTeam, {})
	public teamUsers!: Array<TeamUserEntity>;
}
